export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-26-27af12c6a602573f3902f0ead2e9ad3b.jpg";